import { useState } from "react"
import { IPrimitiveProps } from "../section/Primitive"
import Map, { IMapProps } from "src/libs/yandexMap/Map"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { LANDING_TYPE_CONTENT, YamapContent } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */ 
const YandexMapPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: YamapContent = props.primitive as YamapContent
    const [markers, setMarkers] = useState<any[]>(primitive.markers || [])
    const [mapCoords, setMapCoords]  = useState<number[] | undefined>(primitive.coordinates) 
    const onClick = ( coords : number[] ) => {
        setMapCoords( coords )
        // console.log( coords )
    }
    const onWeel = (coords : number[]) => {
        setMapCoords(coords) 
    }
    const onClusterClick = ( evt:any, coords: number[], data: any[] ) => { 
            
    }
    const updateMarkers = (_events: any[] | null = null) => {

    }
    const onBeforeDrawMap = () : IMapProps => { 
        updateMarkers() 
        return {markers}
    } 

    return <div className='pe-yandex-map-primitive' data-primitive-type={LANDING_TYPE_CONTENT.HTML}>
        <Map
            width="100%" 
            height={ getCssDemention( primitive?.height || 500 ) }
            coordinates={ mapCoords }
            markers={ markers }
            onClick={onClick}
            onClusterClick={onClusterClick}
            onWeel={onWeel}
            onBeforeDrawMap={onBeforeDrawMap} 
        />
    </div>
}
export default YandexMapPrimitive